import ApplicationController from './application_controller'
import EditableText from 'components/EditableText'
import { createRoot } from 'react-dom/client'

class EditableTextController extends ApplicationController {
  connect () {
    const type = $(this.element).data('type') || 'editor'
    const content = Helpers.getEditorContent(this.element, type)

    const root = createRoot(this.element)
    root.render(
      <EditableText type={type} text={content} />
    )
  }
}

export default EditableTextController
